import React, { useEffect, useState } from 'react';
import { Helmet } from "react-helmet";
import Header from "../../components/Header";
import ProductLists from "../../components/ProductList";
import Footer from "../../components/Footer";
import queryString from "query-string";
import Axios from '../../lib/axios/axiosInstance';

import './ProductList.styles.css';

const ProductListBrandWise = () => {

	const [url, setUrl] = useState(false);
	const [leftUrl, setLeftUrl] = useState(false);
	const [baseUrl, setBaseUrl] = useState(false);
	const [name, setName] = useState('');
	// const {name} = useParams();
	const queryParams = queryString.parse(window.location.search)

	useEffect(() => {
		const getName = async () => {
			let response = await Axios.get(`/brand/name/${queryParams.name}`);
			if (response && response.status == 200) {
				setName(response.data.data.getproductvarname);
			}
			else {
				setName(queryParams.name)
			}
		};

		getName().catch(console.error);
		setLeftUrl("/brand/shop-by/" + queryParams.name);
		setBaseUrl("/brand/" + queryParams.name);
		setUrl("/brand/" + queryParams.name + "?offset=0&limit=10");
	}, [queryParams])



	return (
		<div>
			{
				url &&
				<>
					<Helmet>
						<title>Product List</title>
					</Helmet>
					<Header />
					<ProductLists baseUrl={baseUrl} url={url} leftUrl={leftUrl} productBasename={`${name} Brand`} />
					<Footer />
				</>
			}

		</div>
	);
};

export default ProductListBrandWise;